<script setup lang="js">
import { storeToRefs } from 'pinia';

import { useAutoformStore } from '@/stores/autoform.store';
import useModal from '@/stores/modal.store';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import AutoMapModal from '@/components/modals/AutoMapModal.vue';

const autoformStore = useAutoformStore();
const { custom_variables, selectedMapLayersIndex, mapLayers } = storeToRefs(autoformStore);
const { activeModal, closeModal } = useModal();

function getVariableTitle(variableName) {
  let variable = custom_variables.value?.find((v) => v.name == variableName);
  return variable?.title || 'Отсутствует переменная';
}

function openUpdateModal(index) {
  selectedMapLayersIndex.value = index;
  activeModal.value = 'AutoMapModal';
}

function openDeleteModal(index) {
  selectedMapLayersIndex.value = index;
  activeModal.value = 'deleteModal';
}

function deleteMapLayers() {
  mapLayers.value.splice(selectedMapLayersIndex.value, 1);
  closeModal();
}
</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex justify-content-between align-items-center input-btns">
      <div class="add-btn" @click="activeModal = 'AutoMapModal'">
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Добавить автосправочник
      </div>
    </div>
    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Переменная</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(varName, index) in mapLayers" :key="index">
            <td>
              {{ getVariableTitle(varName) }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button" @click="openUpdateModal(index)">
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="openDeleteModal(index)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <DeleteModal
    v-if="activeModal === 'deleteModal'"
    :itemText="'эту строку'"
    @confirmDelete="deleteMapLayers()"
  />

  <AutoMapModal v-if="activeModal === 'AutoMapModal'" />
</template>
